import React from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {PaymentMethodDetails, TKlarnaPaymentMethodStore} from '@/pages/payment-methods'
import {PaymentMethodsKlarnaStoreSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {PaymentMethodType} from '@/constants'
import {COMPANY_NAME} from '@/constants/app'
export const KlarnaPaymentMethod = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<TKlarnaPaymentMethodStore>(PaymentMethodsKlarnaStoreSymbol)

    return (
        <PaymentMethodDetails
            title={t('KlarnaPaymentMethod.title')}
            description={
                <Trans
                    i18nKey='KlarnaPaymentMethod.description'
                    components={{br: <br />}}
                    values={{companyName: COMPANY_NAME}}
                />
            }
            paymentMethodType={PaymentMethodType.klarna}
            stores={store.stores}
        />
    )
})
